import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import MapBoxAcceuil from '../components/MapBoxAcceuil';
import Footer from '../components/Footer';
import Header from '../components/HeaderHome';

const HomePage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Main Content avec ombre améliorée */}
      <main className="flex-grow bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-3xl shadow-[0_0_50px_0_rgba(0,0,0,0.1)] overflow-hidden border border-gray-100">
            <div>
              <MapBoxAcceuil />
            </div>
          </div>
        </div>
      </main>

      {/* Footer avec lien Aydees */}
      <Footer />
    </div>
  );
};

export default HomePage;
